import { IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { useDialog } from '@app/hooks';
import { Strings } from '@app/constants';
import { IInterviewee } from '../types';
import { AddInterviewee } from './add-interviewee-form';
import { AddEmployeePage } from '@app/modules/employees/view/add-employee/add-employee-page';
import { selectCandidateState } from '@app/modules/candidates/selectors';
import { getCandidates } from '@app/modules/candidates/slice';
import { IAddCandidateSchema } from '@app/modules/candidates/types';

interface Props {
  row: IInterviewee;
}

const RowActions = ({ row }: Props) => {
  const promoteAsInterDialog = useDialog();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCandidates());
  }, []);

  const candidateState = useSelector(selectCandidateState);
  const data = candidateState.data?.find(
    (candidate: any) => candidate.email === row.candidateEmail
  );

  const menuPopover = useMenuPopover();
  const editDialog = useDialog();
  const promoteAsEmployeeDialog = useDialog();

  const actions = [
    {
      label: Strings.rowActions.edit,
      callback: editDialog.show,
      disabled: row.status === Strings.status.Selected,
    },
    {
      label: Strings.rowActions.promoteAsIntern,
      callback: promoteAsInterDialog.show,
      disabled: row.status !== Strings.status.Selected,
    },
    {
      label: Strings.rowActions.promoteAsEmployee,
      callback: promoteAsEmployeeDialog.show,
      disabled: row.status !== Strings.status.Selected,
    },
  ];

  return (
    <>
      <IconButton
        onClick={row.status === 'Rejected' ? undefined : menuPopover.show}
        sx={{ color: row.status === 'Rejected' ? 'lightgrey' : 'default' }}
      >
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>

      {editDialog.visible && <AddInterviewee open onClose={editDialog.hide} row={row} />}
      {promoteAsEmployeeDialog.visible && (
        <AddEmployeePage
          open
          onClose={promoteAsEmployeeDialog.hide}
          data={{ ...(data as IAddCandidateSchema), roleId: 5 }}
          roleDisabled={true}
        />
      )}
      {promoteAsInterDialog.visible && (
        <AddEmployeePage
          open
          onClose={promoteAsInterDialog.hide}
          data={{ ...(data as IAddCandidateSchema), roleId: 3 }}
          title={Strings.status.intern}
          roleDisabled={true}
        />
      )}
    </>
  );
};

export { RowActions };
